import React, { MouseEvent, ReactNode, useEffect, useState } from "react";
import { ExpandMore as DropDownIcon, ExpandLess as DropUpIcon } from "@mui/icons-material";

export interface IFloatingProps {
    children: ReactNode,
    clickOutside?: () => void,
    className?: string
}

export const Floating = (props: IFloatingProps) => {
    const onClickOutside = (e: MouseEvent) => {
        if (e.target === e.currentTarget && props.clickOutside) {
            props.clickOutside();
        }
    };

    return (
        <>
            {props.clickOutside && (
                <div className={"floating-container " + (props.className ? props.className : "")} onClick={onClickOutside}></div>
            )}
            <div className={props.className ?? "floating"}>{props.children}</div>
        </>
    );
};

export interface IToggleProps {
    expandedState?: ReactNode,
    collapsedState?: ReactNode
    clickOutside?: () => boolean,
    children: ReactNode,
    label?: ReactNode,
    collapseOnChangeOf?: any
}

export const Toggle = (props: IToggleProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const collapse = () => {
        setIsExpanded(false);
    };

    const clickOutside = () => {
        if (props.clickOutside) {
            if (!props.clickOutside()) {
                collapse();
            }
        } else {
            collapse();
        }
    }
    
    const toggle = () => {
        setIsExpanded(!isExpanded);
    };

    // auto collapse when the value changes
    useEffect(collapse, [props.collapseOnChangeOf]);

    return (
        <div className="toggle-container">
            <span className="toggle-btn" onClick={toggle}>
                {props.label &&
                    <span className="toggle-label">
                        {props.label}
                    </span>
                }

                <span className={"toggle-" + (isExpanded ? "collapse" : "expand")}>
                    {isExpanded ? <DropUpIcon /> : <DropDownIcon />}
                </span>
            </span>

            {isExpanded &&
                <div className="toggle-children">
                    <Floating clickOutside={clickOutside}>{props.children}</Floating>
                </div>
            }
        </div>
    );
};